import { Select, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { mdlIdNameIndexPair } from "../../models/domain/IdNameIndexPair";
import { useEffect } from "react";

export type AgencySelectByHotelPaxIdProps = {
    hotelIds?: string[];
    onChange?: Function;
    value?: string[] | string;
    mode?: "multiple" | "tags" | undefined;
    reset?: boolean;
    crossCheck?: boolean;
    maxTagCount?: number;
    dataSource?: mdlIdNameIndexPair[];
}


export const AgencySelectByHotelPaxId = (props: AgencySelectByHotelPaxIdProps) => {
    const { t } = useTranslation();
    useEffect(() => {
    }, [props.dataSource]);

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    const sendDefaultAgencies = () => {
        var ids = agencies?.map(x => x.id!);
        props.onChange && props.onChange(ids);
        return ids;
    }

    let agencies = props.dataSource && _.orderBy(props.dataSource, [l => l.name?.toLowerCase()]);
    
    return (
        <>
            {
                !agencies ? <Skeleton active={!agencies} /> :
                    <Select
                        loading={!agencies}
                        mode={props.mode}
                        size="middle"
                        onFocus={onFocus}
                        maxTagCount={props.maxTagCount ?? undefined}
                        defaultValue={props.value ? props.value : !props.reset ? sendDefaultAgencies() : undefined}
                        value={!props.value ? !props.reset ? agencies?.map(x => x.id!) : undefined : props.value}
                        onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                        showSearch
                        placeholder={t("common.chooseAgency")}
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={agencies?.map(h => Object.assign(h, {
                            label: h.name,
                            value: h.id
                        }))}
                        allowClear={true}
                    />
            }
        </>
    )
}